import { useTheme } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import PlanLimit from './PlanLimit';
import { useTranslation } from 'react-i18next';

export default function PlansCard() {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  const { userId, companyDetails, user } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  return (
    <>
      {companyDetails?.vessalsAdded === companyDetails?.noOfVessals && user?.type !== 'trader' && <PlanLimit />}
      <Stack style={{ padding: '24px 122px' }}>
        <Stack
          className="!p-[16px]"
          style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderColor: '#8993AC26', borderWidth: '1px' }}
        >
          <Typography
            className="fs-16 ff-Roboto fw-regular"
            color={text}
          >
            {t('Plans')}
          </Typography>
          <Typography
            className="fs-12 ff-Roboto fw-regular"
            color={textLight}
          >
            {t('Some info may be visible to other people using ZeroEmission services')}
          </Typography>
          <Stack className="mt-[24px]">
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              {user?.type !== 'trader' && <Typography
                className="fs-24 ff-Roboto fw-medium"
                color={text}
              >
                {companyDetails?.vessalsAdded || '0'} / {companyDetails?.noOfVessals || '0'}
              </Typography>}
              {user?.type === 'trader' && <Typography
                className="fs-24 ff-Roboto fw-medium"
                color={text}
              >
                {companyDetails?.approvedClientCount || '0'} / {companyDetails?.totalClientCount|| '0'}
              </Typography>}
              <Typography
                className="fs-16 ff-Roboto fw-regular !ml-[5px]"
                color={text}
              >
                {user?.type === 'trader' ? t('Clients Managed') : t('Ships Managed')}
              </Typography>
            </Stack>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('To upgrade your plan limit, please contact your account manager or reach out to support@zeromissions.com')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

    </>
  );
}
